import { addCollection } from '@iconify/vue'

// Internal custom icons
import logo from '@iconify-icons/logo.json';
import flag from '@iconify-icons/flag.json';
import social from '@iconify-icons/social.json';
import spx from '@iconify-icons/spx.json';

// External icons
import flowbite from '@iconify-json/flowbite/icons.json'

/**
 * IconifyPlugin is a Vue plugin that registers Iconify
 * icon collections for use in Vue components.
 *
 * @see build-iconify-icons.mjs on how to build these collections.
 */
const IconifyPlugin = {
  install () {
    addCollection(logo);
    addCollection(flag);
    addCollection(social);
    addCollection(spx);
    addCollection(flowbite);
  }
}

export default IconifyPlugin;
